// extracted by mini-css-extract-plugin
export var active = "bR_bd";
export var answer = "bR_g0";
export var arrow = "bR_9";
export var faq = "bR_hs";
export var heading = "bR_G";
export var question = "bR_ht";
export var section = "bR_j";